import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";

import {
	saveBackOrders,
	saveBulkOrdersHold,
	checkForPrices,
} from "../../../redux/actions";

import PriceSourceOverlayDialog from "../../dialogs/priceSourceOverlayDialog";

class BackOrders extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showPriceSourceOverlayDialog: false,
			selectedPriceSource: null,
			orderDate: null,
			isSelectAll: false,
			errorMessage: null,
			errorList: [],
			itemOrderabilityData: null,
			updateBookedOrderBackOrderWarehouse: null,
		};
		this.handleSelectAll = this.handleSelectAll.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.checkIfAnyFilterSatisfied = this.checkIfAnyFilterSatisfied.bind(this);
	}

	sortByKey(array, key) {
		return array.sort(function(a, b) {
			var x = a[key];
			var y = b[key];
			return x < y ? -1 : x > y ? 1 : 0;
		});
	}

	componentWillMount() {
		const self = this,
			{ backOrders, bulkOrdersHold } = self.props.state.order;
		self.props.getShippingAddressesDetails(self.props.zipCode, false, 'adc_loc', resp => {
			if (self.props.checkIfStateIsAk()) {
				resp = {
					agentid: "SEA",
					dockcity: "SEATTLE"
				};
			}
			if(self.props.deliveryMethod.includes("SDS")) {
				this.setState({
					updateBookedOrderBackOrderWarehouse: resp.agentid,
				});
			} else {
				this.setState({
					updateBookedOrderBackOrderWarehouse: null,
				});
			}
			self.setState({
				warehouseCode: resp.agentid
			}, () => {
				if((backOrders && backOrders.responseObject) && (bulkOrdersHold && bulkOrdersHold.responseObject)) {
					self.fetchOrderDetails();
				} else {
					self.props.resetParallelCallsOrderDetails();
					self.props.checkForBackOrders(self.props.getSelectedAccountNumber(), true, response => {
						self.setState({
							backOrderCallCompleted: true
						}, () => {
							self.callBackAfterCallsCompleted();
						});
					});
					self.props.checkForBulkOrdersHold(self.props.getSelectedAccountNumber(), true, response => {
						self.setState({
							bulkOrderHoldCallCompleted: true
						}, () => {
							self.callBackAfterCallsCompleted();
						});
					});
				}
			});
		}, true, self.props.shippingAddressState);
	}

	callBackAfterCallsCompleted() {
		const self = this;
		const { backOrderCallCompleted, bulkOrderHoldCallCompleted } = self.state;
		if(backOrderCallCompleted && bulkOrderHoldCallCompleted) {
			self.fetchOrderDetails();
		}
	}

	fetchOrderDetails() {
		const self = this,
			{ warehouseCode } = self.state,
			{ backOrders, bulkOrdersHold } = self.props.state.order;
		let orderNumbers = [];
		let skuListForPim = [];
		backOrders && backOrders.responseObject && backOrders.responseObject.forEach(item => {
			if (warehouseCode === item.orderHeader.warehouse.warehouseCode && item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
						i.backOrdNotifications.backOrdNotification = self.sortByKey(i.backOrdNotifications.backOrdNotification, "notificationDate");
						if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
							i.keepOriginalPrice = "Y";
							i.keepOriginalPO = "Y";
							i.selected = self.state.isSelectAll;
							i.originalOrderQuantity = i.orderedQty;
							i.originalOrderNumber = item.orderHeader.orderNumber;
							orderNumbers.push(item.orderHeader.orderNumber);
							let lineDate = null;
							i.backOrdNotifications.backOrdNotification.forEach(notification => {
								if (lineDate === null || moment(lineDate).isAfter(moment(notification.notificationDate))) {
									lineDate = notification.notificationDate;
								}
							});
							if(lineDate) {
								lineDate = moment(lineDate, "YYYY-MM-DD h:mm:ss a").add(7, "days").format("MM/DD/YYYY");
							}
							i.lineDate = lineDate;
							skuListForPim.push(i.item);
						}
					}
				});
			}
		});
		let isThereAnyBulkOrderHold = false;
		bulkOrdersHold && bulkOrdersHold.responseObject && bulkOrdersHold.responseObject.forEach(item => {
			if (warehouseCode === item.orderHeader.warehouse.warehouseCode && self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && i.reservedQty) {
							if(skuListForPim.indexOf(i.item) === -1) {
								skuListForPim.push(i.item);
							}
							i.keepOriginalPrice = "Y";
							i.keepOriginalPO = "Y";
							i.selected = self.state.isSelectAll;
							i.originalReservedQty = i.reservedQty;
							i.originalOrderNumber = item.orderHeader.orderNumber;
							orderNumbers.push(item.orderHeader.orderNumber);
							skuListForPim.push(i.item);
							isThereAnyBulkOrderHold = true;
						}
					});
				}
			}
		});
		self.setState({
			isThereAnyBulkOrderHold
		}, () => {
			skuListForPim = _.uniq(skuListForPim);
			if(skuListForPim.length) {
				let attributeName = "geego_top_load";
				self.props.getOrgAttributesByAttributeName("Top Load Indicator", (resp) => {
					if(!resp) {
						attributeName = "geego_no_top_load";
					}
				    self.props.getPimDataInBatches(skuListForPim, 100, responseObject => {
						self.setState({
							pimDataBackup: responseObject,
							attributeName,
							pimDataCallCompleted: true
						}, () => {
							self.updateBackAndBulkOrdersDetails();
						});
					});
				});
				self.updateItemOrderability(self.props.selectedAddressParams);
			}
			orderNumbers = _.uniq(orderNumbers);
			// Update store with sorted data
			self.props.saveBackOrders(null);
			self.props.saveBackOrders(backOrders);
			self.props.saveBulkOrdersHold(null);
			self.props.saveBulkOrdersHold(bulkOrdersHold);
		});
	}

	updateItemOrderability(selectedAddressParams) {
		const self = this,
			{ warehouseCode } = self.state,
			{ backOrders, bulkOrdersHold } = self.props.state.order;
		let skuList = [];
		backOrders.responseObject.forEach(item => {
			if (warehouseCode === item.orderHeader.warehouse.warehouseCode && item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
						i.backOrdNotifications.backOrdNotification = self.sortByKey(i.backOrdNotifications.backOrdNotification, "notificationDate");
						if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
							skuList.push(i.item);
						}
					}
				});
			}
		});
		bulkOrdersHold.responseObject.forEach(item => {
			if (warehouseCode === item.orderHeader.warehouse.warehouseCode && self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && i.reservedQty) {
							skuList.push(i.item);
						}
					});
				}
			}
		});
		skuList = _.uniq(skuList);
		if(skuList.length) {
			const itemsForItemOrderability = skuList.map(item => `'${item}'`);
			self.props.checkItemOrderabilityInBatches(itemsForItemOrderability, selectedAddressParams, '', true, (response) => {
				self.setState({
					itemOrderabilityData: response
				});
			});
		}
	}

	updateBackAndBulkOrdersDetails() {
		const self = this;
		const { pimDataCallCompleted, attributeName, warehouseCode } = self.state;
		if (pimDataCallCompleted) {
			const errorList = [];
			const responseObject = self.state.pimDataBackup;
			const backOrdersTmp = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
			backOrdersTmp.responseObject.forEach(item => {
				if (warehouseCode === item.orderHeader.warehouse.warehouseCode && item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
							i.backOrdNotifications.backOrdNotification = self.sortByKey(i.backOrdNotifications.backOrdNotification, "notificationDate");
							if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
								i.pricingDate = self.props.pickTheDateFromString(i.linePricingDate);
								i.price = i.itemPrice && i.itemPrice.salesPrice;
								i.agreementNumber = i.lineSANumber;
								i.updatedAgreementNumber = i.lineSANumber;
								i.poNumber = i.lineCustomerPONumber;
								let pimItemData = _.find(responseObject, {item_number: i.item});
								if(pimItemData) {
									i.itemType = self.props.getItemType(i.item, pimItemData);
									i.pointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * i.orderedQty) : 0.00;
									i.updateOrderPointValue =  pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00;
									i.perItemPointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00;
									i.weight = self.props.getOrderWeightFromPimData(pimItemData, i.orderedQty);
									i.perItemWeight = self.props.getOrderWeightFromPimData(pimItemData, 1);
									i.geego_cust_acct = pimItemData.geego_cust_acct;
								}
							}
						}
					});
				}
			});
			const bulkOrdersHoldTmp = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
			bulkOrdersHoldTmp.responseObject.forEach(item => {
				if (warehouseCode === item.orderHeader.warehouse.warehouseCode && self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
					if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
						item.orderDetail.orderLine.forEach((i, index) => {
							if (i.lineStatus.toLowerCase() !== 'cancelled' && i.reservedQty) {
								i.pricingDate = self.props.pickTheDateFromString(i.linePricingDate);
								i.price = i.itemPrice && i.itemPrice.salesPrice;
								i.agreementNumber = i.lineSANumber;
								i.updatedAgreementNumber = i.lineSANumber;
								i.poNumber = i.lineCustomerPONumber;
								let pimItemData = _.find(responseObject, {item_number: i.item});
								if(pimItemData) {
									i.itemType = self.props.getItemType(i.item, pimItemData);
									i.pointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * i.orderedQty) : 0.00;
									i.updateOrderPointValue =  pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00;
									i.perItemPointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00;
									i.weight = self.props.getOrderWeightFromPimData(pimItemData, i.orderedQty);
									i.perItemWeight = self.props.getOrderWeightFromPimData(pimItemData, 1);
									i.geego_cust_acct = pimItemData.geego_cust_acct;
								}
							}
						});
					}
				}
			});
			self.setState({
				errorList,
			}, () => {
				self.props.saveBackOrders(backOrdersTmp);
				self.props.saveBulkOrdersHold(bulkOrdersHoldTmp);
			});
		}
	}

	handleDialog(dialog, flag, e) {
		this.setState({
			["show" + dialog]: false,
		}, () => {
			this.setState({
				["show" + dialog]: flag,
			});
		});
	}

	handleAddToCart(itemx, whichObject, e) {
		const self = this;
		const payload = JSON.parse(JSON.stringify(self.props.state.order[whichObject]));
		payload.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.orderLineId === itemx) {
					i.selected = e.target.checked;
				}
			});
		});
		if (!e.target.checked) {
			self.setState({
				isSelectAll: false,
				errorMessage: '',
			});
		} else {
			self.setState({
				errorMessage: '',
			});
		}
		if (whichObject === 'backOrders') {
			self.props.saveBackOrders(payload);
		} else {
			self.props.saveBulkOrdersHold(payload);
		}
		self.updateOrderPoints();
	}

	updateOrderPoints() {
		setTimeout(() => {
			this.props.updateOrderPoints();
		}, 10);
	}

	handleKeepOriginalPrice(itemx, e) {
		const self = this;
		const payload = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		payload.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.orderLineId === itemx) {
					i.keepOriginalPrice = e.target.checked ? "Y" : "N";
				}
			});
		});
		self.props.saveBackOrders(payload);
		self.updateOrderPoints();
	}

	handleKeepOriginalPO(itemx, whichObject, e) {
		const self = this;
		const payload = JSON.parse(JSON.stringify(self.props.state.order[whichObject]));
		payload.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.orderLineId === itemx) {
					i.keepOriginalPO = e.target.checked ? "Y" : "N";
				}
			});
		});
		if (whichObject === 'backOrders') {
			self.props.saveBackOrders(payload);
		} else {
			self.props.saveBulkOrdersHold(payload);
		}
		self.updateOrderPoints();
	}

	componentWillUnmount() {
		this.handleSelectAll('unmount', { target: { checked: false } });
	}

  	handleSelectAll(whichSelectAll, e) {
		const self = this;
		const { warehouseCode } = self.state;
		const backOrders = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		if (whichSelectAll === 'unmount') {
			backOrders.responseObject.forEach((item, index) => {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
							if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
								i.selected = e.target.checked;
							}
						}
					});
				}
			});
		} else {
			backOrders.responseObject.forEach((item, index) => {
				if (warehouseCode === item.orderHeader.warehouse.warehouseCode && item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
							if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
								i.selected = e.target.checked;
							}
						}
					});
				}
			});
		}
		const bulkOrdersHold = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
		if (whichSelectAll === 'unmount') {
			bulkOrdersHold.responseObject.forEach(item => {
				if (self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
					if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
						item.orderDetail.orderLine.forEach((i, index) => {
							if (i.lineStatus.toLowerCase() !== 'cancelled' && i.originalReservedQty > 0) {
								i.selected = e.target.checked;
							}
						});
					}
				}
			});
		} else {
			bulkOrdersHold.responseObject.forEach(item => {
				if (warehouseCode === item.orderHeader.warehouse.warehouseCode && self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
					if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
						item.orderDetail.orderLine.forEach((i, index) => {
							if (i.lineStatus.toLowerCase() !== 'cancelled' && i.originalReservedQty > 0) {
								i.selected = e.target.checked;
							}
						});
					}
				}
			});
		}
		self.setState({
			isSelectAll: !self.state.isSelectAll,
			errorMessage: '',
		});
		self.props.saveBackOrders(backOrders);
		self.props.saveBulkOrdersHold(bulkOrdersHold);
		self.updateOrderPoints();
	}

	handlePriceSourceDialog(selectedPriceSource, pricingDate, dialog, flag, selectedItem, e) {
		e.preventDefault();
		const self = this;
		let payload = {
			account_number: self.props.getSelectedAccountNumber(),
			pricing_effective_date: moment().tz('America/New_York').format('YYYYMMDD'),
			sa_number: selectedPriceSource,
			item_numbers: [selectedItem.item],
		};
		self.props.checkForPrices(payload, true, false, null, response => {
			let todaysPrice = '';
			if(response.responseObject && response.responseObject.items && response.responseObject.items.length > 0) {
				const item = response.responseObject.items[0];
				if (item.records && item.records.length && item.records[0].adjusted_unit_price) {
					todaysPrice = item.records[0].adjusted_unit_price
				}
			}
			// Make pricing service call to show today's price
			self.setState({
				selectedPriceSource,
				selectedItem: {
					...selectedItem,
					todaysPrice: todaysPrice || "Today's price not available currently."
				},
				orderDate: pricingDate,
			}, () => {
				self.handleDialog(dialog, flag, e);
			});
		});
	}

	handleChangeQuantity(orderNumberIndex, lineIndex, event) {
		const self = this;
		const backOrders = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		backOrders.responseObject.forEach((item, index) => {
			if(index === orderNumberIndex)
			item.orderDetail.orderLine.forEach((i, indx) => {
				if(lineIndex === indx) {
					i.orderedQty = event.target.value;
					if(event.target.value && parseInt(event.target.value, 10)) {
						if(parseInt(event.target.value, 10) > i.originalOrderQuantity) {
							i.orderedQtyError = 'error';
						} else {
							i.orderedQtyError = '';
						}
						i.orderedQtyRequiredError = '';
					} else {
						i.orderedQtyError = '';
						i.orderedQtyRequiredError = 'error';
					}
				}
			});
		});
		self.props.saveBackOrders(backOrders);
		self.updateOrderPoints();
	}

	handleChangeReservedQuantity(orderNumberIndex, lineIndex, event) {
		const self = this;
		const bulkOrdersHold = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
		bulkOrdersHold.responseObject.forEach((item, index) => {
			if(index === orderNumberIndex) {
				item.orderDetail.orderLine.forEach((i, indx) => {
					if(lineIndex === indx) {
						i.reservedQty = event.target.value;
						if(event.target.value && parseInt(event.target.value, 10)) {
							if(parseInt(event.target.value, 10) > i.originalReservedQty) {
								i.reservedQtyError = 'error';
							} else {
								i.reservedQtyError = '';
							}
							i.reservedQtyRequiredError = '';
						} else {
							i.reservedQtyError = '';
							i.reservedQtyRequiredError = 'error';
						}
					}
				});
			}
		});
		self.props.saveBulkOrdersHold(bulkOrdersHold);
		self.updateOrderPoints();
	}

	handlePriceSourceChange(item, whichOrder, index, indx, event) {
		const self = this;
		const agreementNumber = event.target.value;
		self.afterCallUpdateItemsWithPrices(whichOrder, index, indx, agreementNumber, false, false);
		if (agreementNumber) {
			const { keepOriginalPrice, pricingDate } = item;
			// Make pricing parallel service call
			const items = [{
				itemType: 'M',
				agreementNumber,
				item: item.item
			}];
			let pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
			let canWeMakeAnotheCall = false;
			// if keepOriginalPrice is 'Y' then we need to pass that date else we need to pass today's date
			if (keepOriginalPrice === 'Y') {
				pricingEffectiveDate = moment(pricingDate).format('YYYYMMDD');
				canWeMakeAnotheCall = true;
			}
			self.props.makeParallelCallsForCartPrices(
				items,
				true,
				true,
				'order',
				pricingEffectiveDate,
				() => {
					const { prices } = self.props.state.order;
					const flag = self.props.isPricingAvailable({responseObject: {items: prices}});
					if(!canWeMakeAnotheCall) {
						self.afterCallUpdateItemsWithPrices(whichOrder, index, indx, agreementNumber, false, !flag);
					}
					// if pricing is not available then if we can make second call then make it with today's date
					else if(canWeMakeAnotheCall) {
						pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
						self.props.makeParallelCallsForCartPrices(
							items,
							true,
							true,
							'order',
							pricingEffectiveDate,
							() => {
								const { prices } = self.props.state.order;
								const flag = self.props.isPricingAvailable({responseObject: {items: prices}});
								self.afterCallUpdateItemsWithPrices(whichOrder, index, indx, agreementNumber, flag, !flag);
							}
						);
					}
				}
			);
		}
	}

	afterCallUpdateItemsWithPrices(whichOrder, index, indx, agreementNumber, removeKeepUpdatePricing, showError) {
		const self = this;
		const orders = self.props.state.order[whichOrder];
		orders.responseObject[index].orderDetail.orderLine[indx].updatedAgreementNumber = agreementNumber;
		delete orders.responseObject[index].orderDetail.orderLine[indx].updatedAgreementNumberError;
		if (removeKeepUpdatePricing) {
			delete orders.responseObject[index].orderDetail.orderLine[indx].keepOriginalPrice;
			orders.responseObject[index].orderDetail.orderLine[indx].pricingDate = moment().tz('America/New_York').format('MM/DD/YYYY');
		}
		if (showError) {
			window.scrollTo(0, self.props.getElementOffset(`${whichOrder}${index}${indx}`));
			orders.responseObject[index].orderDetail.orderLine[indx].updatedAgreementNumberError = 'error';
		}
		if (whichOrder === 'backOrders') {
			self.props.saveBackOrders(orders);
		} else if (whichOrder === 'bulkOrdersHold') {
			self.props.saveBulkOrdersHold(orders);
		}
	}

	checkIfAnyFilterSatisfied(line) {
		const self = this;
		const { itemOrderabilityData } = self.state;
		if (!itemOrderabilityData) return false;
		return itemOrderabilityData.find(itm => itm.ITEM === line.item && itm.ITEM_ORDERABILITY_FLAG === 'Y') ? true : false;
	}

	render() {
		const self = this;
		const { warehouseCode } = self.state;
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		const selectedAccountsAllPriceSources = self.props.state.user.selectedAccountsAllPriceSources;
		const orderWareHouseCode = self.state.updateBookedOrderBackOrderWarehouse ? self.state.updateBookedOrderBackOrderWarehouse : self.props.state.order.orderDetails.responseObject.warehouseCode;
    	return (
	      	<div>
	        	{backOrders && <div>
					<div>
		                <div className="mb-1">
			                <input type="checkbox" name="chkSelectAll" value="1" id="chkSelectAll1" onClick={this.handleSelectAll.bind(this, 'main')} checked={self.state.isSelectAll} />
			                <label className="bold">{" "}Select ALL Available Products Below</label>
		                </div>
						{ self.state.errorList.length > 0 && <p className="red bold">{self.state.errorList.map(item => item)}</p>}
		                {backOrders && backOrders.responseObject && backOrders.responseObject.map((item, index) => {
							let displayHeader = false;
							if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
								item.orderDetail.orderLine.forEach((i, index) => {
									if (orderWareHouseCode === i.warehouse.warehouseCode && self.checkIfAnyFilterSatisfied(i) && i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
										if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
											displayHeader = true;
										}
									}
								});
								if(!displayHeader) return null;
	                          	const orderDate = self.props.pickTheDateFromString(item.orderHeader.orderDate);
								return <div key={index + 100}>
									<div className="backorder-heading captionAboveTable" style={{ marginTop: 0 }}>
										<div className="bold address">
											{self.props.getAddressFromOrderHeader(item.orderHeader)}
										</div>
										<div className="bold">
											CSO (Order number): {item.orderHeader.orderNumber} &nbsp;
											&nbsp; Order Date: {orderDate} &nbsp;
											&nbsp; P.O. #&nbsp;{item.orderHeader.ponumber} &nbsp;
											{/* &nbsp; Warehouse: {item.orderHeader.warehouse && item.orderHeader.warehouse.warehouseCode} */}
										</div>
									</div>
								  	<table className="dataTable manageOrdersBackordersTable" width="100%">
		                                <thead>
											<tr>
			                                    <th>Add</th>
			                                    <th>Product</th>
			                                    <th>Sales Agreement</th>
												<th className="txt-ctr">Points<br />per Unit</th>
			                                    <th>Quantity<br />Ordered</th>
			                                    <th>Original<br />Price</th>
			                                    <th>Keep<br />Original<br />Price</th>
			                                    <th>Price<br />Info</th>
			                                    <th>Backorder<br />Expires</th>
			                                    <th>Keep<br />Original<br />PO</th>
												<th>ADC</th>
											</tr>
		                                </thead>
		                                {item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0 && item.orderDetail.orderLine.map((i, indx) => {
											if(i.lineStatus.toLowerCase() === 'cancelled' || !self.props.isBackOrderHold(i)) return null;
		                                    if (orderWareHouseCode === i.warehouse.warehouseCode && self.checkIfAnyFilterSatisfied(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
												if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
			                                        return <tbody key={indx}>
			                                            <tr id={`backOrders${index}${indx}`}>
															<td>
																<input type="checkbox" disabled={self.props.isAnyModelIsRestrictedInSelectedAccount(i)} name="chkAddCart" value="1" id="chkAddCart1" onClick={e => this.handleAddToCart(i.orderLineId, 'backOrders', e)} checked={i.selected} />
															</td>
															<td>
																{i.item}
																{self.props.isAnyModelIsRestrictedInSelectedAccount(item) && <p className="red">GEA is not currently selling this model to this account.</p>}
															</td>
															<td>
																{selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject &&
																	<select disabled={!i.selected} className={i.updatedAgreementNumberError + ' prodQuote'} value={i.updatedAgreementNumber} id={"prodQuote"+indx} onChange={this.handlePriceSourceChange.bind(this, i, 'backOrders', index, indx)} name="prodQuote" style={{ width: '90%' }}>
																		<option value="" key={0}>-- Select --</option>
																		{!selectedAccountsAllPriceSources.responseObject.find(sa => sa.AGREEMENT_NUMBER === i.agreementNumber) &&
																			<option value={i.agreementNumber} key={selectedAccountsAllPriceSources.responseObject.length + 1}>{i.agreementNumber}</option>
																		}
																		{selectedAccountsAllPriceSources.responseObject.filter((itm)=>{
																			return itm.PRICE_LIST_NAME != "APPLIANCES - BLEM LOAD PRICE LIST" && itm.AGREEMENT_TYPE !== 'GEA Parts'
																			}).map((item, index) => {
																			return <option value={item.AGREEMENT_NUMBER} key={(index + 1)}>{item.DISPLAY_AGREEMENT_NAME}</option>
																		})}
																	</select>
																}
															</td>
															<td className="txt-ctr">{i.updateOrderPointValue}</td>
															<td>
																<input className={i.orderedQtyError || i.orderedQtyRequiredError} onChange={this.handleChangeQuantity.bind(this, index, indx)} type="text" value={i.orderedQty} onKeyPress={this.props.acceptNumbersOnly} style={{width: '50%', textAlign: 'center'}}/>
																{i.orderedQtyError && <p className="red">Quantity can not be greater than original quantity.</p>}
																{i.orderedQtyRequiredError && <p className="red">Please enter quantity greater than 0.</p>}
															</td>
															<td>${i.itemPrice && i.itemPrice.salesPrice}</td>
															<td>
			                                                	<input type="checkbox" name="chkOrigPrice" value="1" id="chkOrigPrice1" onClick={e =>this.handleKeepOriginalPrice(i.orderLineId, e)} checked={i.keepOriginalPrice === "Y"} />
			                                              	</td>
															<td>
																<a className="priceSource m-auto" href="" onClick={this.handlePriceSourceDialog.bind(this, i.updatedAgreementNumber, i.pricingDate, "PriceSourceOverlayDialog", true, {redirectFrom: 'backorders', item: i.item})}>$</a>
															</td>
															<td>
																<span className="red">
																	{i.lineDate}
																</span>
															</td>
															<td>
																<input type="checkbox" name="chkOrigPO" value="1" id="chkSelectAll1" onClick={e => this.handleKeepOriginalPO(i.orderLineId, 'backOrders', e)} checked={i.keepOriginalPO === "Y"} />
																<label htmlFor="chkOrigPO1">{" "}{i.lineCustomerPONumber}</label>
															</td>
															<td className="txt-ctr">{i.warehouse && i.warehouse.warehouseCode}</td>
			                                            </tr>
		                                          	</tbody>
												}
		                                    }
	                                    	return null;
	                                  	})}
		                              </table>
		                            </div>
		                          ;
								}
							return null;
	                    })}
						{self.state.isThereAnyBulkOrderHold && <h1 className="pageTitle">Bulk Hold Orders</h1>}
						{bulkOrdersHold && bulkOrdersHold.responseObject && bulkOrdersHold.responseObject.map((item, index) => {
							if (warehouseCode === item.orderHeader.warehouse.warehouseCode && self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
								let displayOrder = false;
								if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
									item.orderDetail.orderLine.forEach((i, index) => {
										if (self.checkIfAnyFilterSatisfied(i) && !(i.lineStatus.toLowerCase() === 'cancelled' || !i.originalReservedQty)) {
											displayOrder = true;
										}
									});
								}
								if(!displayOrder) return null;
	                          	const orderDate = self.props.pickTheDateFromString(item.orderHeader.orderDate);
								return <div key={index + 100}>
									<div className="backorder-heading captionAboveTable" style={{ marginTop: 0 }}>
										<div className="bold address">
											{self.props.getAddressFromOrderHeader(item.orderHeader)}
										</div>
										<div className="bold">
											CSO (Order number): {item.orderHeader.orderNumber} &nbsp;
											&nbsp; Order Date: {orderDate} &nbsp;
											&nbsp; P.O. #&nbsp;{item.orderHeader.ponumber} &nbsp;
											&nbsp; Warehouse: {item.orderHeader.warehouse && item.orderHeader.warehouse.warehouseCode}
										</div>
									</div>
								  	<table className="dataTable manageOrdersBackordersTable" width="100%">
		                                <thead>
											<tr>
			                                    <th>Move<br />to Cart</th>
			                                    <th>Product</th>
			                                    <th>Sales Agreement</th>
			                                    <th>Quantity<br />Ordered</th>
												<th>Quantity<br />Reserved</th>
			                                    <th>Original<br />Price</th>
			                                    <th>Price<br />Info</th>
			                                    <th>Keep&nbsp;Original&nbsp;PO</th>
											</tr>
		                                </thead>
		                                {item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0 && item.orderDetail.orderLine.map((i, indx) => {
											if(!self.checkIfAnyFilterSatisfied(i) || i.lineStatus.toLowerCase() === 'cancelled' || !i.originalReservedQty) return null;
	                                        return <tbody key={indx}>
	                                            <tr id={`bulkOrdersHold${index}${indx}`}>
													<td>
														<input type="checkbox" disabled={self.props.isAnyModelIsRestrictedInSelectedAccount(i)} name="chkAddBCart" value="1" id="chkAddBCart1" onClick={e => this.handleAddToCart(i.orderLineId, 'bulkOrdersHold', e)} checked={i.selected} />
													</td>
													<td>
														{i.item}
														{self.props.isAnyModelIsRestrictedInSelectedAccount(item) && <p className="red">GEA is not currently selling this model to this account.</p>}
													</td>
													<td>
														{selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject &&
															<select disabled={!i.selected} className={i.updatedAgreementNumberError + ' prodQuote'} value={i.updatedAgreementNumber} id={"prodQuote"+indx} onChange={this.handlePriceSourceChange.bind(this, i, 'bulkOrdersHold', index, indx)} name="prodQuote" style={{ width: '90%' }}>
																<option value="" key={0}>-- Select --</option>
																{!selectedAccountsAllPriceSources.responseObject.find(sa => sa.AGREEMENT_NUMBER === i.agreementNumber) &&
																	<option value={i.agreementNumber} key={selectedAccountsAllPriceSources.responseObject.length + 1}>{i.agreementNumber}</option>
																}
																{selectedAccountsAllPriceSources.responseObject.map((item, index) => {
																	return <option value={item.AGREEMENT_NUMBER} key={(index + 1)}>{item.DISPLAY_AGREEMENT_NAME}</option>
																})}
															</select>
														}
													</td>
													<td>
														{i.orderedQty}
													</td>
													<td>
														<input className={i.reservedQtyError || i.reservedQtyRequiredError} onChange={this.handleChangeReservedQuantity.bind(this, index, indx)} type="text" value={i.reservedQty} onKeyPress={this.props.acceptNumbersOnly} style={{width: '50%', textAlign: 'center'}}/>
														{i.reservedQtyError && <p className="red">Reserved Quantity can not be greater than original reserved quantity.</p>}
														{i.reservedQtyRequiredError && <p className="red">Please enter reserved quantity greater than 0.</p>}
													</td>
													<td>${i.itemPrice && i.itemPrice.salesPrice}</td>
													<td>
														<a className="priceSource m-auto" href="" onClick={this.handlePriceSourceDialog.bind(this, i.updatedAgreementNumber, i.pricingDate, "PriceSourceOverlayDialog", true, {redirectFrom: 'backorders', item: i.item})}>$</a>
													</td>
													<td>
														<input type="checkbox" name="chkOrigPO" value="1" id="chkSelectAll1" onClick={e => this.handleKeepOriginalPO(i.orderLineId, 'bulkOrdersHold', e)} checked={i.keepOriginalPO === "Y"} />
														<label htmlFor="chkOrigPO1">{" "}{i.lineCustomerPONumber}</label>
													</td>
	                                            </tr>
                                          	</tbody>
	                                  	})}
	                              	</table>
	                            </div>
							}
							return null;
	                    })}
	              	</div>
            	</div>}
	        	{this.state.showPriceSourceOverlayDialog ?
					<PriceSourceOverlayDialog
						formatMoney={this.props.formatMoney}
						isResponsibilityExists={this.props.isResponsibilityExists}
						orderDate={this.state.orderDate}
						selectedAccountsAllPriceSources={this.props.state.user.selectedAccountsAllPriceSources}
						selectedItem={this.state.selectedItem}
						priceSource={this.state.selectedPriceSource}
						showDialog={true}
						handleDialog={this.handleDialog}
						typeOfAccount={this.props.getSelectedAccountType()}
					/> : null}
			</div>
    	);
	}
}
const mapStateToProps = state => {
	return { state };
};

const mapDispatchToProps = dispatch => ({
	saveBackOrders: data => dispatch(saveBackOrders(data)),
	saveBulkOrdersHold: data => dispatch(saveBulkOrdersHold(data)),
	checkForPrices: (payload, showLoader, saveToStore, cartOrOrder, response) => dispatch(checkForPrices(payload, showLoader, saveToStore, cartOrOrder, response)),
});

BackOrders = connect(
	mapStateToProps,
	mapDispatchToProps,
)(BackOrders);

export default BackOrders;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/updateBookedOrderBackOrders.js